import React, { useRef, useState, useEffect, useLayoutEffect, useCallback } from 'react'
import Api from '../../_helpers/Api'
import InfiniteScroll from 'react-infinite-scroller'
import { useAuthDataContext } from '../../_providers/Auth'
import loader from '../../assets/img/loader.svg'
import { useMessagesContext } from '../../_providers/Messages'
import { useSocketContext } from '../../_providers/Socket'
import { trans } from '../../_providers/Translation'

// libraries
import { Button } from '@mui/material'

// images
import closeImage from "@/assets/img/chat/icons/close.svg"
import sendImage from "@/assets/img/chat/icons/send.svg"

// components
import SingleMessage from '@/components/partials/SingleMessage.jsx'

let scrollInterval

function MessagePanel(props) {
    const auth = useAuthDataContext()
    const messages = useMessagesContext()

    const width = 300
    const margin = 50
    const number = props.number || 0
    const position = number * (width + margin) + margin

    const ref = useRef(null)
    const formRef = useRef(null)

    const [state, setState] = useState({
        user: null,
        loading: true,
        list: [],
        pages: 0,
        count: 0,
        unread: 0,
        hasMore: true,
        initScroll: true,
        scroll: false,
        hidden: false,
        refetch: false,
    })
    const [message, setMessage] = useState('')

    useEffect(() => {
        let el = ref.current

        if (el) {
            el.addEventListener('scroll', e => {

                setState(prev => ({
                    ...prev,
                    initScroll: false
                }))

                if (el.scrollTop + el.offsetHeight === el.scrollHeight) {
                    console.log('scrolled to bottom')

                    clearInterval(scrollInterval)
                }
            })
        }

    }, [ref])

    useEffect(() => {
        loadUser()
        // loadUnread()
        loadData()
    }, [props.user, state.refetch])

    useEffect(() => {

        if (state.loading) {
            return
        }

        messages.fromSocket.map(m => {

            let condition = Number(m.author.id) === Number(props.user.id) && m.author.type === props.user.type

            if (m.reservation_id) {
                condition = condition && Number(m.reservation_id) === Number(props.user.reservationId)
            }

            if (condition) {
                let exists = inList(m.id)

                if (!exists) {
                    setState(prev => ({
                        ...prev,
                        list: prev.list.concat(m),
                        initScroll: Math.random().toString(),
                    }))

                    if (!state.hidden) {
                        markAsRead(m.id)
                    } else {
                        loadUnread()
                    }
                }
            }
        })
    }, [messages.fromSocket])

    useEffect(() => {
        messages.read.map(m => {
            let newData = [...getMessagesList()]
            let index = findIndex(m.id)

            if (newData[index]) {
                newData[index].read_at = m.read_at

                setState(prev => ({
                    ...prev,
                    list: newData
                }))
            }
        })

        setState(prev => ({
            ...prev,
            list: prev.list.map(msg => {
                messages.read.map(m => {
                    if (Number(msg.id) === Number(m.id)) {
                        msg.read_at = m.read_at
                    }
                })

                return msg
            })
        }))
    }, [messages.read])

    // маркира непрочетените съобщения като прочетени
    // при разпъване на панела
    useEffect(() => {
        if (state.hidden) {
            return
        }

        const unread = [...getMessagesList()].filter(m => m.read_at === null)

        unread.map(m => {
            markAsRead(m.id)
        })
    }, [state.hidden])

    useEffect(() => {
        if (state.initScroll) {
            // scrollInterval = setInterval(() => {
            scrollToBottom()
            // }, 100);
        }
    }, [state.initScroll])

    function getMessagesList() {
        return state.list.reduce((acc, m) => {
            let exists = acc.findIndex(msg => Number(msg.id) === Number(m.id))

            if (exists === -1) {
                acc.push(m)
            }
            return acc
        }, [])
    }

    const scrollToBottom = () => {
        let el = ref.current

        if (el) {
            el.scrollTop = el.scrollHeight
        }
    }

    const shouldScroll = useCallback(() => {
        let el = ref.current

        if (el) {
            if (el.scrollTop + el.offsetHeight === el.scrollHeight) {
                return true
            }
        }

        console.log(el.scrollTop + el.offsetHeight, el.scrollHeight)

        return false
    }, [ref, getMessagesList()])


    const loadUser = () => {
        let url = 'profiles/find?id=' + props.user.id + '&type=' + props.user.type + '&tenant_id=' + props.user.tenant_id

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    user: res.data
                }))
            })
    }

    const loadUnread = () => {
        let url = 'messages/unread-from-user?tenant_id=' + props.user.tenant_id + '&subject_id=' + props.user.id + '&subject_type=' + props.user.type + '&reservation_id=' + props.user.reservationId

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    unread: res.data
                }))
            })
    }

    const loadData = (page = 1) => {
        // Build params to match backend validation logic
        const params = []
        params.push('page=' + page)
        if (props.user.tenant_id) {
            params.push('tenant_id=' + props.user.tenant_id)
        }
        if (props.user.reservationId && !isNaN(props.user.reservationId)) {
            params.push('reservation_id=' + props.user.reservationId)
        }
        if (
            typeof props.user.id !== 'undefined' && props.user.id !== null && !isNaN(props.user.id)
        ) {
            params.push('subject_id=' + props.user.id)
        }
        if (
            typeof props.user.type !== 'undefined' && props.user.type !== null && props.user.type !== ''
        ) {
            params.push('subject_type=' + props.user.type)
        }
        let url = 'messages/get?' + params.join('&')

        Api.get(url)
            .then(res => {
                messages.loadCount()
                // loadUnread()

                let filtered = res.data.items.filter(m => {
                    if (inList(m.id)) {
                        return false
                    }
                    return true
                })

                setState(prev => ({
                    ...prev,
                    list: [...prev.list, ...filtered], // append at end
                    pages: res.data.pages,
                    hasMore: res.data.has_more,
                    loading: false,
                }))

                if (Number(page) === 1) {
                    setTimeout(scrollToBottom, 50)
                }
            })
    }

    const markAsRead = id => {
        Api.post('messages/mark-as-read', {
            id: id
        }).then(() => {
            setState(prev => ({
                ...prev,
                list: prev.list.map(m => {
                    if (m.id === id) {
                        m.read_at = true
                    }

                    return m
                })
            }))

            messages.loadCount()
            // loadUnread()
        })
    }

    const inList = id => {
        let exists = getMessagesList().filter(o => {
            return Number(o.id) === Number(id)
        })[0]

        return exists
    }

    const findIndex = id => {
        return getMessagesList().findIndex(m => {
            return Number(id) === Number(m.id)
        })
    }

    const handleClose = () => {
        messages.closeChat(props.user.chatId)
    }

    const handleToggle = () => {
        setState(prev => ({
            ...prev,
            hidden: !prev.hidden
        }))
    }

    const handleChangeText = e => {
        messages.whisper(props.user.id, props.user.type, auth.user())
        setMessage(e.target.value)
    }

    const handleClickText = e => {
        if (!e.shiftKey && e.key === 'Enter') {
            sendMessage(e.target.closest('form'))
        }
    }

    const handleSubmit = e => {
        e.preventDefault()

        sendMessage(e.target)
    }

    const sendMessage = form => {
        if (!message || !message.trim()) return // Block empty messages

        let data = new FormData(form)
        data.append('receiver_id', props.user.id)
        data.append('receiver_type', props.user.type)
        data.append('message', String(message))

        if (props.user.reservationId) {
            data.append('reservation_id', props.user.reservationId)
        }

        // Ensure tenantId is always set, fallback to auth.tenant_id if missing
        let tenantId = props.user.receiver_tenant_id || props.user.tenant_id || (auth.tenant_id && auth.tenant_id())
        if (tenantId) {
            data.append('receiver_tenant_id', tenantId)
        }
        form.reset()
        setMessage('')

        const endpoint = 'messages/send'
        Api.post(endpoint, data)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    list: [...prev.list, res.data], // append at end
                    initScroll: Math.random().toString(),
                }))
                messages.setLastMessage(res.data)
                setTimeout(scrollToBottom, 50) // scroll after render
            })
    }

    function handleDelete(id) {
        setState(prev => ({
            ...prev,
            list: prev.list.filter(m => m.id !== id)
        }))
    }

    function handleEdit(id, newText) {
        setState(prev => ({
            ...prev,
            list: prev.list.map(m => {
                if (m.id === id) {
                    m.message = newText
                }
                return m
            }
            )
        }))
    }


    return (
        <div className={['message-panel', state.hidden ? 'hidden' : ''].join(' ')} style={{ right: position }}>
            <div className="head" onClick={handleToggle}>
                <picture>
                    {props.user && props.user.avatar && (
                        <img src={props.user.avatar} alt="avatar" />
                    )}
                </picture>

                <span className="name">
                    {props.user
                        ? `${props.user.name} ${props.user.lastname}`
                        : ''
                    }
                    {props.user.source == 'internal' && (
                        <span style={{
                            background: '#ff9800',
                            color: '#fff',
                            borderRadius: '6px',
                            padding: '2px 8px',
                            marginLeft: '8px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}>
                            External Partner
                        </span>
                    )}
                </span>
                <span className="close" onClick={handleClose}>
                    <img src={closeImage} alt="close" />
                </span>
            </div>

            <div className="body" ref={ref}>
                {state.loading
                    ?
                    <img src={loader} alt="loading" />
                    :
                    <InfiniteScroll
                        element="ul"
                        initialLoad={false}
                        pageStart={1}
                        loadMore={loadData}
                        hasMore={state.hasMore}
                        loader={<img key="loader" src={loader} alt="loading" />}
                        useWindow={false}
                        isReverse={false}
                        getScrollParent={() => ref.current}
                    >
                        {getMessagesList().map((m, i) =>
                            m.id ? (
                                <SingleMessage
                                    message={m}
                                    index={i}
                                    onDelete={handleDelete}
                                    onEdit={handleEdit}
                                />
                            ) : null
                        )}
                    </InfiniteScroll>
                }

                {messages.whispers[props.user.fullId]
                    ?
                    <div className="whisper">{messages.whispers[props.user.fullId].name} пише...</div>
                    :
                    ''
                }

            </div>

            <div className="input">
                <form ref={formRef} onSubmit={handleSubmit} autoComplete="off">
                    <textarea
                        type="text"
                        name="message"
                        placeholder={trans("random.writeMessage")}
                        defaultValue=""
                        onChange={handleChangeText}
                        onKeyUp={handleClickText}
                        value={message}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={message.trim() === ''}
                    >
                        <img src={sendImage} alt="send" />
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default MessagePanel